"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulletPointList = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./BulletPointList.scss");
var BulletPointList = function BulletPointList(_ref) {
  var bulletPoints = _ref.bulletPoints,
    className = _ref.className;
  if (!Array.isArray(bulletPoints) || !bulletPoints.length) {
    return null;
  }
  var rootClassName = (0, _classnames["default"])('cds-ProductBox-BulletPointList', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName,
    dangerouslySetInnerHTML: {
      __html: bulletPoints.join('&nbsp; | &nbsp;')
    }
  });
};
exports.BulletPointList = BulletPointList;